import { c as _c } from "react/compiler-runtime";
import { graphql, readFragment } from "@opensea/graphql";
import { Chip, formatAddress } from "@opensea/ui-kit";
export const ProfileAddressChipFragment = graphql(`
  fragment ProfileAddressChip on Profile {
    address
  }
`);
export function ProfileAddressChip(t0) {
  const $ = _c(12);
  let profileKey;
  let rest;
  if ($[0] !== t0) {
    ({
      profile: profileKey,
      ...rest
    } = t0);
    $[0] = t0;
    $[1] = profileKey;
    $[2] = rest;
  } else {
    profileKey = $[1];
    rest = $[2];
  }
  let T0;
  let t1;
  let t2;
  if ($[3] !== profileKey || $[4] !== rest) {
    const profile = readFragment(ProfileAddressChipFragment, profileKey);
    T0 = Chip;
    t1 = rest;
    t2 = formatAddress(profile.address, {
      display: "compact"
    });
    $[3] = profileKey;
    $[4] = rest;
    $[5] = T0;
    $[6] = t1;
    $[7] = t2;
  } else {
    T0 = $[5];
    t1 = $[6];
    t2 = $[7];
  }
  let t3;
  if ($[8] !== T0 || $[9] !== t1 || $[10] !== t2) {
    t3 = <T0 {...t1}>{t2}</T0>;
    $[8] = T0;
    $[9] = t1;
    $[10] = t2;
    $[11] = t3;
  } else {
    t3 = $[11];
  }
  return t3;
}